var _circle, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDeleteicon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_444",
    "data-name": "Group 444",
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_33",
    "data-name": "Ellipse 33",
    cx: 20,
    cy: 20,
    r: 20,
    fill: "#9e3323"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "trash",
    transform: "translate(10 9)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_134",
    "data-name": "Path 134",
    d: "M20.92,6.73a78.776,78.776,0,0,0-15.8-.2l-2.04.2a.755.755,0,0,1-.83-.68.745.745,0,0,1,.67-.82l2.04-.2a81.144,81.144,0,0,1,16.11.2.751.751,0,0,1,.67.82.741.741,0,0,1-.74.68Z",
    transform: "translate(-2.246 -1.25)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_135",
    "data-name": "Path 135",
    d: "M8.371,5.71a.753.753,0,0,1-.61-.86l.22-1.31c.16-.96.38-2.29,2.71-2.29h2.62c2.34,0,2.56,1.38,2.71,2.3l.22,1.3a.746.746,0,1,1-1.47.25l-.22-1.3c-.14-.87-.17-1.04-1.23-1.04H10.7c-1.06,0-1.08.14-1.23,1.03l-.23,1.3a.75.75,0,0,1-.74.63A.615.615,0,0,1,8.371,5.71Z",
    transform: "translate(-2.246 -1.25)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_136",
    "data-name": "Path 136",
    d: "M8.79,22.75c-3.49,0-3.63-1.93-3.74-3.49L4.4,9.19a.752.752,0,0,1,1.5-.1l.65,10.07c.11,1.52.15,2.09,2.24,2.09h6.42c2.1,0,2.14-.57,2.24-2.09L18.1,9.09a.764.764,0,0,1,.8-.7.751.751,0,0,1,.7.8l-.65,10.07c-.11,1.56-.25,3.49-3.74,3.49Z",
    transform: "translate(-2.246 -1.25)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_137",
    "data-name": "Path 137",
    d: "M10.33,17.25a.75.75,0,1,1,0-1.5h3.33a.75.75,0,1,1,0,1.5Z",
    transform: "translate(-2.246 -1.25)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_138",
    "data-name": "Path 138",
    d: "M9.5,13.25a.75.75,0,0,1,0-1.5h5a.75.75,0,0,1,0,1.5Z",
    transform: "translate(-2.246 -1.25)",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeleteicon);
export default __webpack_public_path__ + "static/media/deleteicon.bd1bd8999cc87a6d64abec146fa21ae0.svg";
export { ForwardRef as ReactComponent };